// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__1bNk4","subheader":"ReorderModal_subheader__soeIh","listWrap":"ReorderModal_listWrap__2TcIE"};